import React, { useState } from 'react';
import * as locCon from '../LocalConstants';
import CustomText from '../elements/CustomText';
import { RefContextLanguage } from '../providers/LanguageProvider';
import * as libCon from '../community-hats-js-library/Constants';
import CollectionStatus from '../elements/CollectionStatus';
import {
  RefHouseIntakeFormStatus,
  RefParticipantIntakeFormStatus,
  refreshHouseIntakeForm,
  refreshParticipantIntakeForm,
} from '../hooks/BundleDeviceHooks';
import { showErrorDialogByCode } from '../utils/dialogFunctions';
import { showNotification } from '../utils/generalFunctions';
import CustomSpin from '../elements/CustomSpin';
import CustomButton, { CustomPrimaryButtonWithDisability } from '../elements/CustomButton';
import { RefATObjectId, RefStoredNested } from '../hooks/StoreHooks';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import { RefSetCurrentPage } from '../hooks/NavigationHooks';
import { SimpleCopyField } from '../elements/SimpleStoreCopyField';
import { formatDistanceShort, formatToStudyLocationReadable } from '../community-hats-js-library/utils/dateFunctions';

export const ParticipantIntakeFormStatus = ({ includeTitle = true }) => {
  const i18n = RefContextLanguage();

  const [status, message] = RefParticipantIntakeFormStatus();
  const lastChecked = RefStoredNested(locCon.FORMS_LAST_CHECKED, libCon.PARTICIPANT_INTAKE_FORM);
  const objectId = RefATObjectId(locCon.AT_OBJECT_PARTICIPANT);

  return (
    <IntakeFormStatusViewer
      title={includeTitle ? <div>{i18n.t('participantIntakeForm')}</div> : undefined}
      status={status}
      message={message}
      objectId={objectId}
      refreshObject={refreshParticipantIntakeForm}
      incompleteDescription={i18n.t('addParticipant')}
      formPageId={locCon.PAGE_PARTICIPANT_INTAKE_FORM}
      formButtonText={i18n.t('participantIntakeForm')}
      lastChecked={lastChecked}
    />
  );
};

export const HouseIntakeFormStatus = ({ includeTitle = true }) => {
  const i18n = RefContextLanguage();

  const [status, message] = RefHouseIntakeFormStatus();
  const lastChecked = RefStoredNested(locCon.FORMS_LAST_CHECKED, libCon.HOUSE_INTAKE_FORM);
  const objectId = RefATObjectId(locCon.AT_OBJECT_HOUSE);

  return (
    <IntakeFormStatusViewer
      title={includeTitle ? <div>{i18n.t('houseIntakeForm')}</div> : undefined}
      status={status}
      message={message}
      objectId={objectId}
      refreshObject={refreshHouseIntakeForm}
      incompleteDescription={i18n.t('addHouse')}
      formPageId={locCon.PAGE_HOUSE_INTAKE_FORM}
      formButtonText={i18n.t('houseIntakeForm')}
      lastChecked={lastChecked}
    />
  );
};

function IntakeFormStatusViewer({
  title,
  status,
  message,
  objectId,
  refreshObject,
  incompleteDescription,
  formPageId,
  formButtonText,
  lastChecked,
}) {
  const i18n = RefContextLanguage();

  // Current Page
  const setCurrentPage = RefSetCurrentPage();

  const [isSynching, setIsSynching] = useState(false);

  const refreshRecords = async () => {
    setIsSynching(true);
    let response = await refreshObject();

    if (response !== libCon.OK) showErrorDialogByCode(response);
    else showNotification(i18n.t('refreshComplete'));

    setIsSynching(false);
  };

  return (
    <div className="verticalSection">
      {!isNullOrUndefined(title) ? <CustomText type={locCon.SECTION_TITLE_TEXT}>{title}</CustomText> : <></>}
      <CollectionStatus status={status} message={message} title={i18n.t('status')} />

      <SimpleCopyField
        title={i18n.t('lastRefreshed')}
        value={
          isNullOrUndefined(lastChecked) ? (
            i18n.t('never')
          ) : (
            <>
              {`${formatToStudyLocationReadable(lastChecked, true, false)}`}
              <br />
              {`(${formatDistanceShort(lastChecked)})`}
            </>
          )
        }
        enableCopy={false}
      />

      <div className="verticalSection">
        {isSynching ? (
          <CustomSpin type={locCon.BUTTON_SPINNER} />
        ) : (
          <CustomPrimaryButtonWithDisability
            isDisabled={isNullOrUndefined(objectId)}
            title={i18n.t('incompleteDeployment')}
            description={incompleteDescription}
            onClick={() => refreshRecords()}
          >
            {i18n.t('refresh')}
          </CustomPrimaryButtonWithDisability>
        )}
      </div>

      {status === libCon.DEVICE_STATUS_WAITING_COLLECTION ? (
        <div className="verticalSection">
          <CustomText type={locCon.ELEMENT_TITLE_TEXT}>{i18n.t('goToForm')}</CustomText>
          <CustomText type={locCon.INSTRUCTIONS_TEXT}>{i18n.t('followLinkAndAdministerForm')}</CustomText>
          <CustomButton
            style={{ marginTop: '1.5vh' }}
            type={locCon.PRIMARY_BUTTON}
            onClick={() => setCurrentPage(formPageId)}
          >
            {formButtonText}
          </CustomButton>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}
